import { render, staticRenderFns } from "./ScenarioMenuSettings.vue?vue&type=template&id=67c3bd44&scoped=true"
import script from "./ScenarioMenuSettings.vue?vue&type=script&lang=js"
export * from "./ScenarioMenuSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3bd44",
  null
  
)

export default component.exports